/**
 * Firebase エラーメッセージ統一ユーティリティ
 * 
 * Firebase Authentication のエラーコードを
 * 日本語のユーザーフレンドリーなメッセージに変換
 */

/**
 * エラーメッセージマップ
 */
const ERROR_MESSAGES = {
  // 認証エラー
  'auth/invalid-credential': 'メールアドレスまたはパスワードが正しくありません。',
  'auth/user-not-found': 'ユーザーが見つかりません。',
  'auth/wrong-password': 'パスワードが正しくありません。',
  'auth/email-already-in-use': 'このメールアドレスは既に使用されています。',
  'auth/invalid-email': 'メールアドレスの形式が正しくありません。',
  'auth/weak-password': 'パスワードが弱すぎます。より強力なパスワードを設定してください。',
  'auth/too-many-requests': 'ログイン試行回数が多すぎます。しばらく待ってから再試行してください。',
  'auth/operation-not-allowed': 'この操作は許可されていません。',
  
  // Firestore エラー
  'permission-denied': '権限がありません。管理者にお問い合わせください。',
  'not-found': '指定されたデータが見つかりません。',
  'already-exists': 'すでに存在しています。',
  'invalid-argument': '入力された情報が正しくありません。',
  'failed-precondition': '必要な条件が満たされていません。',
  'unauthenticated': '認証が必要です。再度ログインしてください。'
};

/**
 * Firebase エラーをユーザーフレンドリーなメッセージに変換
 * 
 * @param {Error} error - Firebase エラーオブジェクト
 * @returns {string} ユーザー向けエラーメッセージ
 */
export function getFirebaseErrorMessage(error) {
  const errorCode = error?.code || '';
  return ERROR_MESSAGES[errorCode] || error?.message || '予期しないエラーが発生しました。';
}

/**
 * 特定のエラーコードかどうかをチェック
 * 
 * @param {Error} error - エラーオブジェクト
 * @param {string} code - チェックするエラーコード
 * @returns {boolean}
 */
export function isFirebaseError(error, code) {
  return error?.code === code;
}

/**
 * 認証関連のエラーかどうかをチェック
 * 
 * @param {Error} error - エラーオブジェクト
 * @returns {boolean}
 */
export function isAuthError(error) {
  return error?.code?.startsWith('auth/') || false;
}



